<template>
  <div class="col-xs-12">
    <div class="clearfix">
      <quote-accessorial-item
        v-if="originServiceCode"
        :reporting-currency="reportingCurrency"
        :job-currency="jobCurrency"
        :quote-currency="quoteCurrency"
        :rate="rate"
        :rate-request="rateRequest"
        type="Origin"
        :job-accessorials="originJobAccessorials"
        :service-code="originServiceCode"
        @add-accessorial="addOriginJobAccesorial"
      />
      <quote-accessorial-item
        v-if="destinationServiceCode"
        :reporting-currency="reportingCurrency"
        :job-currency="jobCurrency"
        :quote-currency="quoteCurrency"
        :rate="rate"
        :rate-request="rateRequest"
        type="Destination"
        :job-accessorials="destinationJobAccessorials"
        :service-code="destinationServiceCode"
        @add-accessorial="addDestinationJobAccesorial"
      />
    </div>
  </div>
</template>

<script>
  import QuoteAccessorialItem from './QuoteAccessorialItem'

  export default {
    name: 'QuoteAccessorials',
    components: { QuoteAccessorialItem },
    props: {
      job: {
        type: Object,
        required: false
      },
      reportingCurrency: {
        type: String,
        required: true
      },
      rate: {
        type: Object,
        required: true
      },
      rateRequest: {
        type: Object,
        required: true
      },
      jobAccessorials: {
        type: Array,
        required: false
      }
    },
    watch: {
      originJobAccessorials: {
        deep: true,
        handler: function (newVal) {
          this.updateJobAccessorials()
        }
      },
      destinationJobAccessorials: {
        deep: true,
        handler: function (newVal) {
          this.updateJobAccessorials()
        }
      }
    },
    data () {
      return {
        originJobAccessorials: [],
        destinationJobAccessorials: []
      }
    },
    computed: {
      originServiceCode () {
        const originItem = this.rate.item.find(({service}) => service === 'OA' || service === 'OZ')
        return originItem && originItem.service
      },
      destinationServiceCode () {
        const destinationItem = this.rate.item.find(({service}) => service === 'DA' || service === 'DZ')
        return destinationItem && destinationItem.service
      },
      quoteCurrency () {
        return this.rateRequest.ResponseCurrency || this.reportingCurrency
      },
      jobCurrency () {
        return (this.job && this.job.quoteCurrency && this.job.quoteCurrency.code) || this.reportingCurrency
      }
    },
    mounted () {
      this.loadSavedJobAccessorials()
    },
    methods: {
      addOriginJobAccesorial (item) {
        this.originJobAccessorials.push(item)
        this.updateJobAccessorials()
      },
      addDestinationJobAccesorial (item) {
        this.destinationJobAccessorials.push(item)
        this.updateJobAccessorials()
      },
      updateJobAccessorials () {
        this.$emit('update-job-accessorials', [...this.originJobAccessorials, ...this.destinationJobAccessorials])
      },
      loadSavedJobAccessorials () {
        if (this.jobAccessorials) {
          if (this.originServiceCode) {
            this.originJobAccessorials = this.jobAccessorials
              .filter(item => {
                return (item.accessorial.service === this.originServiceCode) || (item.accessorial.serviceClass && item.accessorial.serviceClass.code === this.originServiceCode)
              })
              .map(this.mapJobAccessorial)
          }
          if (this.destinationServiceCode) {
            this.destinationJobAccessorials = this.jobAccessorials
              .filter(item => {
                return (item.accessorial.service === this.destinationServiceCode) || (item.accessorial.serviceClass && item.accessorial.serviceClass.code === this.destinationServiceCode)
              })
              .map(this.mapJobAccessorial)
          }
        }
      },
      mapJobAccessorial (item) {
        const service = item.accessorial.service || (item.accessorial.serviceClass && item.accessorial.serviceClass.code)
        const minimumCost = item.accessorial.minimumCost
        const description = item.accessorial.note ? `${item.accessorial.description} (${item.accessorial.note})` : item.accessorial.description
        const exchangeRate = item.exchangeRate || 1
        return {
          accessorial: {...item.accessorial, service},
          quantity: item.quantity,
          description,
          ratesPerName: item.accessorial.ratesPerName,
          rateText: `${this.numberFormat(item.amount)} ${item.currency.code}`,
          rate: item.accessorial.rate,
          baseRate: item.baseAmount.toFixed(2),
          currency: item.currency,
          baseCurrency: item.baseCurrency.code,
          exchangeRate,
          get baseMinimumCost () {
            return this.exchangeRate ? minimumCost / this.exchangeRate : minimumCost
          },
          get baseSubtotal () {
            const calculated = this.baseRate * this.quantity
            const baseSubTotal = this.baseMinimumCost && (this.baseMinimumCost > calculated) ? this.baseMinimumCost : calculated
            return baseSubTotal.toFixed(2)
          },
          get subtotal () {
            const calculated = this.rate * this.quantity
            const subtotal = calculated && minimumCost && (minimumCost > calculated) ? minimumCost : calculated
            return subtotal.toFixed(2)
          }
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// QuoteAccessorials.vue?c31238b6